import { Chip, Theme } from "@mui/material";
import { lighten } from "@mui/material/styles";
import { createStyles, makeStyles, withStyles } from "@mui/styles";

export const useExportOptionsStyles = makeStyles((theme: Theme) =>
  createStyles({
    chip: {
      borderRadius: "6px",
      margin: "8px",
    },
    listOption: {
      fontSize: "14px",
    },
    groupHeader: {
      textTransform: "uppercase",
      fontFamily: "cera-pro-bold",
      color: theme.palette.primary.main,
      fontSize: "16px",
    },
    rowDiv: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    selectionPanel: {
      background: lighten(theme.palette.background.paper, 0.14),
      minHeight: "60px",
    },
    selectionCount: {
      textAlign: "right",
      paddingRight: "12px",
      paddingTop: "10px",
      color: "#fff",
      fontSize: "0.75rem",
      lineHeight: "1",
    },
    selectionCountError: {
      textAlign: "right",
      paddingRight: "12px",
      paddingTop: "10px",
      color: theme.palette.error.main,
      fontSize: "0.75rem",
      lineHeight: "1",
    },
    selectionText: {
      paddingLeft: "12px",
      paddingTop: "10px",
      color: "#fff",
      fontSize: "0.75rem",
      lineHeight: "1",
    },

    textBox: {
      borderRadius: "4px",
    },
  })
);

export const BadChip = withStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
  },
}))(Chip);
